module.exports = require("@angular/cdk/portal");


//////////////////
// WEBPACK FOOTER
// external "@angular/cdk/portal"
// module id = 1002
// module chunks = 0